import React from 'react';
import { FormattedMessage } from 'react-intl';
import { FLOW_TYPE } from '../../../framework/App/AppConstants';

const LOCALE_PREFIX = 'GB/pages/CAPage/CreditDetailsPopup';

export const changeInstallmentLink = ({ flow, installmentCount, showCYCO, nsid }) => {
    let href = showCYCO ? 'cycopage' : 'changeInstallment';

    if (nsid) {
        href = `${href}?nsid=${nsid}`;
    }

    if ((flow === FLOW_TYPE.HERMES) && (installmentCount > 0)) {
        return (
            <a
                href={href}
                data-automation-id="changeInstallment"
                id="changeInstallment"
                className="vx_text-body-sm"
            >
                <FormattedMessage
                    id={`${LOCALE_PREFIX}.changeInstallment`}
                />
            </a>
        );
    }
};
